<template>
  <div>
    <div class="flex justify-right" :class="inQuestionModal ? 'pt-3' : 'pt-4 pb-4 pl-4 pr-2'">
      <textarea
        id="infoRowTextfield"
        v-model="localTextFieldValue"
        type="text"
        :name="fieldName"
        :aria-label="placeholder"
        rows="3"
        class="form-input rounded-lg bg-transparent transition ease-in-out duration-150 sm:text-sm sm:leading-5 flex-grow"
        :class="inQuestionModal ? '' : 'mr-2'"
        :placeholder="placeholder"
      />
      <button
        v-if="!brandedActionType"
        class="px-4 py-2 text-gray-brand-600 border border-transparent font-semibold text-sm rounded-full hover:border-gray-brand-600 flex-grow-0"
        @click="savedOption"
      >
        {{ actionText }}
      </button>
    </div>
    <QuestionFooterButtons
      v-if="brandedActionType && !inlineMode"
      :action-text="actionText"
      :can-proceed="canProceed"
      :show-skip="showOptionalButton"
      @next="savedOption"
      @skip="skipQuestion"
    />
    <div v-if="brandedActionType && inlineMode" class="p-4 pt-0 mt-1">
      <PrimaryButton
        @click="savedOption"
        class="w-full"
        :class="{
          'cursor-pointer opacity-100': canProceed,
          'cursor-not-allowed opacity-50': !canProceed
        }"
        :size="'xl'"
        :streaking="canProceed"
        :justify="'justify-center'"
      >
        {{ actionText }}
      </PrimaryButton>
    </div>
    <div v-if="showCancelButton" class="p-4 pt-0 -mt-1">
      <SecondaryButton v-if="brandedActionType" @click="cancelAnswer" class="w-full" :size="'xl'">
        Cancel
      </SecondaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from '@/components/Molecules/PrimaryButton'
import SecondaryButton from '@/components/Molecules/SecondaryButton'
import QuestionFooterButtons from '@/components/Checkout/QuestionFooterButtons'
export default {
  name: 'InfoRowEditTextarea',
  components: { PrimaryButton, SecondaryButton, QuestionFooterButtons },
  props: ['textFieldValue', 'placeholder', 'actionText', 'actionType', 'name', 'optional', 'mode'],
  inject: {
    inQuestionModal: { default: false }
  },
  data() {
    return {
      localTextFieldValue: this.textFieldValue
    }
  },
  computed: {
    brandedActionType() {
      return this.actionType == 'branded'
    },
    fieldName() {
      if (this.name && this.name.length > 0) return this.name
      return 'infoRowTextarea'
    },
    canProceed() {
      return this.inlineMode || !!(this.localTextFieldValue && this.localTextFieldValue?.length > 0)
    },
    showOptionalButton() {
      return this.optional && !this.inlineMode
    },
    showCancelButton() {
      return this.inlineMode
    },
    inlineMode() {
      return this.mode == 'inline'
    }
  },
  mounted() {},
  methods: {
    savedOption() {
      if (this.canProceed) {
        this.$emit('savedOption', this.localTextFieldValue)
      }
    },
    skipQuestion() {
      this.$emit('skipQuestion')
    },
    cancelAnswer() {
      this.$emit('cancelAnswer')
    }
  }
}
</script>
